import useModalClickOutside from "utils/useModalClickOutside";
import BottomModal from "components/common/Modal/BottomModal";
import { useHomeNewsRader } from "utils/clientAPIs/newsRader";
import Image from "next/image";
import moment from "moment-timezone";
import { TYPO } from "styles/Typo";
import { useHandleImageErrorVer2 } from "utils/useHandleImageError";
import Icon, { ICONS } from "components/common/Icons";
import { useRouter } from "next/router";
import { useModalClose } from "lib/analytics/react/modal";
import { TrackedList, TrackedListItem } from "lib/analytics/react/list";

function NewLaderDetailModal({ setModalOpen, isModalOpen }: any) {
  const { trackClose } = useModalClose();
  const modalRef = useModalClickOutside(setModalOpen);
  const { data, isLoading, isError } = useHomeNewsRader();
  const { getStockLogoSafe } = useHandleImageErrorVer2();
  const router = useRouter();
  const formatNewsDate = (d: string) =>
    router.locale === "ko"
      ? moment(d).format("M월 D일")
      : moment(d).format("MMM D");

  if (isLoading) return <div></div>;
  if (isError) return <div></div>;
  if (data?.length === 0) return null;

  return (
    <BottomModal
      isOpen={isModalOpen}
      modalRef={modalRef}
      containerClass="max-h-[80%] overflow-y-auto scroll !p-0"
    >
      <div className="relative">
        <div className="py-2 pr-2 flex justify-end bg-background sticky top-0 z-[1] ">
          <div
            className="p-[6px] cursor-pointer"
            onClick={() => {
              trackClose("cancel");
              setModalOpen(false);
            }}
          >
            <Icon name={ICONS.CLOSE} fill="var(--gray90)" />
          </div>
        </div>
        <div className="p-6">
          <TrackedList
            listId="explore_bs_latest_news"
            totalCount={data?.length}
          >
            {data?.map((item: any, index: number) => (
              <TrackedListItem
                key={index}
                itemData={{
                  kind: "newsrader",
                  newsrader_id: item?.ID,
                  ticker: item?.ITEM_CD_DL,
                  rank: index + 1,
                }}
                href={`/detail/${item.ITEM_CD_DL}?tab=aireport`}
                onClick={() => {
                  trackClose("success");
                  setModalOpen(false);
                }}
                data-testid="new-leader-list"
              >
                <div>
                  <div className="flex items-stretch ">
                    <div className="w-[48px] flex flex-col  shrink-0 items-end">
                      <p
                        className={`text-gray60 ${TYPO.TYPO8_RG} whitespace-nowrap`}
                        data-testid="new-leader-modal-date"
                      >
                        {formatNewsDate(item.BASE_DT)}
                      </p>
                      <p
                        className={`${TYPO.TYPO8_RG} ${
                          Number(item?.ADJ_CLOSE_CHG?.toFixed(1)) === 0
                            ? "text-gray70"
                            : item?.ADJ_CLOSE_CHG > 0
                            ? "text-red40"
                            : "text-blue40"
                        }`}
                      >
                        {Number(item?.ADJ_CLOSE_CHG?.toFixed(1)) > 0 ? "+" : ""}
                        {item?.ADJ_CLOSE_CHG?.toFixed(1)}%
                      </p>
                    </div>
                    <div className="px-4">
                      <div
                        className="h-full w-[1px]  relative"
                        style={{
                          background:
                            index === 0
                              ? "linear-gradient(180deg, rgba(229, 232, 235, 0.00) 0%, #E5E8EB 100%)"
                              : index === data?.length - 1
                              ? "linear-gradient(180deg, #E5E8EB 0%, rgba(229, 232, 235, 0.00) 100%)"
                              : "var(--hairlineBorder)",
                        }}
                      />
                    </div>
                    <div className="flex flex-col gap-2 pb-[30px]">
                      <div className="flex gap-1 items-center">
                        <Image
                          src={getStockLogoSafe(item.ITEM_CD_DL)}
                          alt={item.ITEM_CD_DL}
                          width={18}
                          height={18}
                          className="rounded-[6px]"
                        />
                        <p
                          className={`${TYPO.TYPO8_MD} text-gray70 leading-[20px]`}
                          data-testid="new-leader-modal-name"
                        >
                          {item.ITEM_KR_NM}
                        </p>
                      </div>
                      <div className="flex gap-1 items-center flex-wrap">
                        {item?.KEYWORD?.split(",")?.map(
                          (keyword: string, index: number) => (
                            <p
                              key={index}
                              className={`bg-gray10 rounded-[6px] px-1 ${TYPO.TYPO7_1_MD} text-gray80 whitespace-nowrap`}
                              data-testid="new-leader-modal-keyword"
                            >
                              {keyword}
                            </p>
                          )
                        )}
                      </div>
                      <p
                        className={` text-gray70 leading-[24.5px] text-[14px] tracking-[-0.28px] custom-word-break font-[400] `}
                      >
                        {item.DESCRIPTION}
                      </p>
                    </div>
                  </div>
                </div>
              </TrackedListItem>
            ))}
          </TrackedList>
        </div>
      </div>
    </BottomModal>
  );
}

export default NewLaderDetailModal;
